import { forwardRef } from "react";
import { useReducedMotion } from "motion/react";
import * as m from "motion/react-m";
import { motionTokens } from "./tokens";

export const HeroArtifactPositioner = forwardRef(function HeroArtifactPositioner(
  {
    active = false,
    activeZIndex = 20,
    children,
    offset = 0,
    style,
    zIndex = 1,
    ...props
  },
  ref,
) {
  const shouldReduceMotion = useReducedMotion();
  const y = active ? 0 : offset;
  const finalStyle = { ...style, zIndex: active ? activeZIndex : zIndex };

  if (shouldReduceMotion) {
    return (
      <div ref={ref} style={{ ...finalStyle, transform: `translate3d(0, ${y}px, 0)` }} {...props}>
        {children}
      </div>
    );
  }

  return (
    <m.div
      ref={ref}
      initial={false}
      animate={{ y }}
      transition={{
        duration: motionTokens.duration.supporting,
        ease: motionTokens.easing.entrance,
      }}
      style={finalStyle}
      {...props}
    >
      {children}
    </m.div>
  );
});
